import { Link } from "react-router-dom";

const stats = [
  { value: "2000+", label: "影视内容条目" },
  { value: "520+", label: "深度评论专题" },
  { value: "每日", label: "资讯持续更新" },
  { value: "全站", label: "多终端自适应" },
];

export default function SiteIntro() {
  return (
    <section className="bg-gradient-to-br from-primary-600 to-primary-900 py-14 md:py-20">
      <div className="mx-auto max-w-page px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs">
            <i className="ri-video-line" />
            关于影视工厂
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-4xl text-background-50 tracking-wide">
            一站式获取权威影视内容
          </h2>
          <p className="mt-5 text-sm md:text-base text-background-200 leading-8">
            影视工厂专注于电影与电视剧的内容聚合与深度解读。我们为影视爱好者、追剧观众和内容创作者，
            提供最新上映资讯、剧集推荐、资源介绍与影视热点解析，让每一次浏览都成为一次轻松的探索。
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="px-6 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解我们
            </Link>
            <Link
              to="/contact"
              className="px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="rounded-lg bg-background-50/10 p-5 md:p-6">
              <p className="font-heading text-3xl md:text-4xl text-accent-400 tracking-wide">
                {stat.value}
              </p>
              <p className="mt-2 text-xs md:text-sm text-background-200">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}